import React from 'react';
import { ToastContainer } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faExclamationCircle } from '@fortawesome/pro-light-svg-icons';

function MssToast() {
  return (
    <ToastContainer
      position="top-right"
      autoClose={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable={false}
      theme="light"
      className="mss__toast"
      icon={({ type }) => {
        if (type === 'success') return <FontAwesomeIcon icon={faThumbsUp} size="xl" />;
        if (type === 'error') return <FontAwesomeIcon icon={faExclamationCircle} size="xl" />;
        return '';
      }}
    />
  );
}

export default MssToast;
